module.exports = __webpack_public_path__ + "static/Sweep_panel-9bd7d2c94499792160846e35230ddb55.png";